import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cn } from "@/utils/utils"

interface LabelProps {
    disabled?: boolean;
    required?: boolean;
}

function Label({
    className,
    disabled,
    required,
    ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & LabelProps & {
    asChild?: boolean
}) {
    return (
        <LabelPrimitive.Root
            data-slot="label"
            className={cn(
                "flex items-center gap-2 text-sm text-[var(--on-surface-variant)] leading-none select-none mb-2",
                disabled && "text-gray-400",
                !disabled && "group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
                className
            )}
            {...props}
        >
            {props.children}
            {required && <span className="text-red-500">*</span>}
        </LabelPrimitive.Root>
    )
}

export { Label }
